/**
 * Cart Service
 * Handles shopping cart operations (localStorage + backend sync)
 */

const CART_STORAGE_KEY = 'shop_cart';

const cartService = {
  // Get cart from localStorage
  getCart() {
    try {
      const cart = localStorage.getItem(CART_STORAGE_KEY);
      return cart ? JSON.parse(cart) : [];
    } catch (error) {
      console.error('Error reading cart:', error);
      return [];
    }
  },

  // Save cart to localStorage
  saveCart(items) {
    try {
      localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      console.error('Error saving cart:', error);
    }
  },

  // Add item to cart
  addItem(product, quantity = 1, variation = null) {
    const cart = this.getCart();
    const existingIndex = cart.findIndex(item => 
      item.productId === product.id && 
      JSON.stringify(item.variation) === JSON.stringify(variation)
    );

    if (existingIndex >= 0) {
      cart[existingIndex].quantity += quantity;
    } else {
      cart.push({
        productId: product.id,
        product,
        quantity,
        variation,
        addedAt: new Date().toISOString()
      });
    }

    this.saveCart(cart);
    return cart;
  },

  // Remove item from cart
  removeItem(productId, variation = null) {
    let cart = this.getCart();
    cart = cart.filter(item => 
      !(item.productId === productId && 
        JSON.stringify(item.variation) === JSON.stringify(variation))
    );
    this.saveCart(cart);
    return cart;
  },

  // Update quantity
  updateQuantity(productId, quantity, variation = null) {
    const cart = this.getCart();
    const item = cart.find(item => 
      item.productId === productId && 
      JSON.stringify(item.variation) === JSON.stringify(variation)
    );

    if (item) {
      item.quantity = Math.max(1, quantity);
      this.saveCart(cart);
    }
    return cart;
  },

  // Clear cart
  clearCart() {
    localStorage.removeItem(CART_STORAGE_KEY);
    return [];
  },

  // Get cart total
  getTotal() {
    const cart = this.getCart();
    return cart.reduce((total, item) => {
      return total + (item.product.price * item.quantity);
    }, 0);
  },

  // Merge guest cart with user cart (after login)
  async mergeWithBackend(userId) {
    const guestCart = this.getCart();
    if (guestCart.length === 0) return;

    try {
      // TODO: Send guest cart to backend to merge with user's cart
      console.log('Merging cart with backend for user:', userId);
      // await apiService.post('/shop/cart/merge', { items: guestCart });
    } catch (error) {
      console.error('Error merging cart:', error);
    }
  }
};

export default cartService;

